import ActionMetaBuilder from 'storeState/ActionMetaBuilder';

export const PREFIX = "PROJECTS";

export const actionMeta = new ActionMetaBuilder(PREFIX);

actionMeta.defineRequest({
  name: "projects_list",
  urlBuilder: ({tenant_id}) => 'projects/?tenant_id='+(tenant_id ? tenant_id : '')
});

actionMeta.defineRequest({
    name: "project_delete",
    urlBuilder: ({project_id}) => 'projects/'+project_id
});

actionMeta.defineRequest({
    name: "project_create",
    urlBuilder: () => 'projects/'
});

actionMeta.defineRequest({
    name: "project_update",
    urlBuilder: ({project_id}) => 'projects/'+project_id
});



// WEBPACK FOOTER //
// ./src/storeState/projects/meta.js